module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_24.png?77d0f667e3cddd35ec80056d911777ae";